(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDeleteController',AeropuertoDeleteController);

    AeropuertoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aeropuerto'];

    function AeropuertoDeleteController($uibModalInstance, entity, Aeropuerto) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aeropuerto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
